import { Show } from 'solid-js'
import { Portal } from 'solid-js/web'
import { Motion, Presence } from 'solid-motionone'
import { MainContent } from './components/main-content'
import { PreviewAnim } from './components/preview-anim'
import { rewardState } from './store'

export function RewardFlow() {
  return (
    <Portal>
      <Presence>
        <Show when={rewardState.items}>
          <Motion.div
            class="fixed inset-0 z-50 flex flex-col bg-[#52A386]"
            style={{ background: rewardState.background ?? undefined }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, easing: [0.33, 1, 0.68, 1] }}
          >
            <Presence exitBeforeEnter>
              <Show
                when={rewardState.previewAnim}
                keyed
                fallback={
                  <Show
                    when={rewardState.items?.[rewardState.currentIndex]}
                    keyed
                  >
                    {(item) => (
                      <MainContent
                        item={item}
                        items={rewardState.items!}
                        currentIndex={rewardState.currentIndex}
                      />
                    )}
                  </Show>
                }
              >
                {(state) => <PreviewAnim state={state} />}
              </Show>
            </Presence>
          </Motion.div>
        </Show>
      </Presence>
    </Portal>
  )
}
